import { Action, createAction } from 'redux-act';

import PlaceActivationData from '../../../models/form/PlaceActivationData';
import PlaceActivationResult from '../../../models/interfaces/PlaceActivationResult';
import FetchPayload from '../FetchPayload';
import TimestampPayload from '../TimestampPayload';

export interface ActivatePlacePayload {
  placeActivationData: PlaceActivationData;
  token: string;
}
export const activatePlace = createAction<ActivatePlacePayload>('ACTIVATE_PLACE');
export type ActivatePlaceActionType = Action<ActivatePlacePayload>;

export interface PlaceActivationResultPayload extends TimestampPayload {
  placeActivationResult: PlaceActivationResult;
}
export const placeActivationFinished = createAction<PlaceActivationResultPayload>('PLACE_ACTIVATION_FINISHED');
export const placeActivationFailed = createAction<PlaceActivationResultPayload>('PLACE_ACTIVATION_FAILED');

export interface FetchActivatePlacePayload extends FetchPayload {
  token: string;
}
export const fetchActivatePlace = createAction<FetchActivatePlacePayload>('FETCH_ACTIVATE_PLACE');
export type FetchActivatePlaceActionType = Action<FetchActivatePlacePayload>;

export interface FetchedActivatePlacePayload extends TimestampPayload {
  placeActivationData: PlaceActivationData;
}
export const activatePlaceFetched = createAction<FetchedActivatePlacePayload>('ACTIVATE_PLACE_FETCHED');

export type ActivatePlaceFetchFailedPayload = TimestampPayload;
export const activatePlaceFetchFailed = createAction<ActivatePlaceFetchFailedPayload>('ACTIVATE_PLACE_FETCH_FAILED');
